import React                from 'react';
import classnames           from 'classnames';
import { FontAwesomeIcon }  from '@fortawesome/react-fontawesome';

import ErrorLabel        from 'pu-react/components/base/ErrorLabel';

const ParseBomParameters = (props) => {
  return(
    <div className="parameters">
      <div className="subtitle">
        Identify Row:
      </div>

      <div className="row">
        <div className="col-md-5">
          <div className="d-flex align-items-top">
            <div>
              <div className="d-flex align-items-center">
                <label className="d-flex align-items-top">
                  <span className="first-row-square">&#9632;</span>
                  1st Data Row
                </label>
                <input 
                  className="mx-2 form-control form-control-sm bom-parameters" 
                  type="number" min="1" 
                  name="first_row"
                  value={props.parameters.first_row || ''} 
                  onChange={e => props.onChange('first_row', e.target.value)} />
              </div>
              <ErrorLabel error={props.errors.first_row} />
            </div>
          </div>
        </div>
        <div className="col-md-7">
          <div className="d-flex align-items-top float-end">
            <div>
              <div className="d-flex align-items-center">
                <label className="p-2">
                  <strong>
                    Board Quantity
                  </strong>
                </label>
                <input type="number" 
                 className="mx-2 form-control form-control-sm" 
                 name="quantities[0]" 
                 value={props.parameters.quantities[0]} 
                 onChange={e => props.onChange('qty1', e.target.value)} />
                <input type="number" 
                 className="mx-2 form-control form-control-sm" 
                 name="quantities[1]" 
                 value={props.parameters.quantities[1]} 
                 onChange={e => props.onChange('qty2', e.target.value)} />
                <input type="number" 
                 className="mx-2 form-control form-control-sm" 
                 name="quantities[2]" 
                 value={props.parameters.quantities[2]} 
                 onChange={e => props.onChange('qty3', e.target.value)} />
                <input type="number" 
                 className="mx-2 form-control form-control-sm" 
                 name="quantities[3]" 
                 value={props.parameters.quantities[3]} 
                 onChange={e => props.onChange('qty4', e.target.value)} />
              </div>
              <ErrorLabel error={props.errors.quantities} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ParseBomParameters;